<template>

    <div class="header">

        <div class="header__row" :class="{'header__row__desktop-size': showHeaderDesktop}" v-show="newslettersSearchingMode === ENUM.NEWSLETTERS.SEARCHING_MODE.UNACTIVE && !showHeaderDesktop">

            <div class="header__mobile">

                <div v-if="fetchStatus === ENUM.FETCH_STATUS.PARTIAL" class="header__mobile__left">
                    <lottie-loader :size="16"></lottie-loader>
                    <span class="text-baseMedium ml__8">{{ $t('partial_fetch_scan_in_progress') }}</span>
                </div>
                <div v-else-if="showFetchDone" class="header__mobile__left">
                    <img src="/img/newsletters-v2/check-list-on.svg" class="img__20 mr__8">
                    <span class="text-baseMedium">{{ $t('partial_fetch_scan_done_title') }}</span>
                </div>
                <button class="header__btn__mail" v-else-if="!isDesktop" @click="openBSMS">
                    <img v-if="atLeastOneShutdown" src="/img/icons/alert-red.svg" class="img__20 mr__4">
                    <p class="text-baseMedium header__btn__mail__text">{{ $t('cleaning_select_inbox') }}</p>
                    <img src="/img/newsletters-v2/chevron-down-blue.svg" class="img__20">
                </button>


            </div>

            <button class="header__btn__history" @click="goMyActions">
                <img src="/img/newsletters-v2/clock-blue.svg" class="img__20 img__lang">
                <p class="text-baseMedium color__charcoal header__btn__history__text">{{ $t('reverse_action') }}</p>
            </button>
        </div>

        <template v-if="newslettersSearchingMode === ENUM.NEWSLETTERS.SEARCHING_MODE.UNACTIVE && !showHeaderDesktop">
            <div class="header__row" :class="{'header__border' : !isList}">
                <header-toggle :desktopSize="showHeaderDesktop"></header-toggle>

                <div class="header__line">
                    <button class="header__btn__search" :class="{'desktop-size': showHeaderDesktop}"  @click="search(true)">
                        <img src="/img/newsletters-v2/search-blue.svg" class="img__16 img__lang">
                    </button>

                    <button class="header__btn__sort"
                            :class="{
                        'header__btn__sort__active': newslettersSort !== ENUM.NEWSLETTERS.SORT.NOT_SET,
                        'desktop-size': showHeaderDesktop
                    }"
                            @click="openSort">
                        <img src="/img/newsletters-v2/sort-ascending.svg" class="img__20">
                        <p class="text-baseMedium header__btn__sort__text ellipsis-text">{{ computedSortTitle }}</p>
                    </button>
                </div>
            </div>

        </template>

        <div class="header__desktop" :class="{'header-row-desktop-size': showHeaderDesktop}"  v-show="showHeaderDesktop">
            <div class="header__desktop__side">
                <div class="label little-label mr__8" @click="search(true)">
                    <img src="/img/newsletters-v2/search-blue.svg" class="img__20">
                </div>
                <div class="label" :class="{'header__btn__sort__active': newslettersSort !== ENUM.NEWSLETTERS.SORT.NOT_SET}" @click="openSort">
                    <img src="/img/newsletters-v2/sort-ascending.svg" class="img__20 mr__8">
                    <span>{{ computedSortTitle }}</span>
                </div>
            </div>
            <div class="header__desktop__middle">
                <header-toggle :desktopSize="showHeaderDesktop"></header-toggle>
            </div>
            <div class="header__desktop__side">
                <div class="label" @click="goMyActions">
                    <img src="/img/newsletters-v2/clock-blue.svg" class="img__20 mr__8">
                    <span>{{$t('reverse_action')}}</span>
                </div>
            </div>
        </div>

        <header-categories v-show="isList && newslettersSearchingMode === ENUM.NEWSLETTERS.SEARCHING_MODE.UNACTIVE && innerWidth < 1100"
                           :category="category"
                           :subscriptions="subscriptions"
                           @updateCategory="updateCategory"></header-categories>

        <div class="header__search" :class="{'desktop-size': showHeaderDesktop}" v-show="newslettersSearchingMode !== ENUM.NEWSLETTERS.SEARCHING_MODE.UNACTIVE">

            <label class="header__search__label" for="searchInput">
                <img src="/img/newsletters-v2/search-blue.svg" class="img__20">
                <input type="text"
                       id="searchInput"
                       ref="searchInput"
                       v-model="modelSearchValue"
                       class="header__search__input text-baseSemibold"
                       :placeholder="$t('cleaning_search_cta')">
                <img src="/img/newsletters-v2/x-blue.svg" class="img__24 ml__8 pointer"
                     @click="search(false)"
                     v-show="showHeaderDesktop">
            </label>
            <button class="text-lSemibold color__aquamarine ds__link__default"
                    @click="search(false)"
                    v-show="!showHeaderDesktop">
                {{ $t('cleaning_cancel_actions') }}
            </button>
        </div>

        <sort ref="SORT"></sort>

        <bottom-sheet-mailboxes-selection ref="BSMS"></bottom-sheet-mailboxes-selection>

    </div>

</template>

<script>
import Vuex from 'vuex'

import ENUM from '@/assets/ENUM'

import Storage from '@/helpers/storage'
import Tag from '@/modules/tag'

import BottomSheetMailboxesSelection from '@/components/bottomSheet/BottomSheetMailboxesSelection'
import CircleProgressBar from '@/components/newsletters-v2/CircleProgressBar'
import HeaderCategories from '@/components/newsletters-v2/HeaderCategories'
import HeaderToggle from '../../components/newsletters-v2/HeaderToggle'
import LottieLoader from '../lottie/LottieLoader'
import Sort from '@/components/newsletters-v2/sort/Sort'

export default {

    name: 'newsletters-header',

    components: {
        BottomSheetMailboxesSelection,
        CircleProgressBar,
        HeaderCategories,
        HeaderToggle,
        LottieLoader,
        Sort
    },

    props: {

        category: {
            type: String,
            default: ''
        },

        subscriptions: {
            type: Array,
            default: () => []
        },

        maxSubscriptions: {
            type: Number,
            default: 0
        }
    },

    watch: {

        modelSearchValue(newValue) {
            if (newValue !== this.searchValue) {
                this.updateSearchValue(newValue)
            }
        },

        searchValue(newValue) {
            if (newValue !== this.modelSearchValue) {
                this.modelSearchValue = newValue
            }
        },

        fetchStatus(newValue) {
            if (newValue === ENUM.FETCH_STATUS.DONE && this.newslettersWaiting) {
                this.showFetchDone = true
                setTimeout(() => {
                    this.showFetchDone = false
                }, 3000)
            }

        }
    },

    computed: {

        ...Vuex.mapGetters([
            'fetchStatus',
            'innerWidth',
            'mailboxes',
            'newslettersPage',
            'newslettersWaiting',
            'newslettersSearchingMode',
            'newslettersSort',
            'page',
            'searchValue'
        ]),

        computedSelected() {
            return this.$tc('cleaning_list_selected', this.countSelectedNewsletters, {nbSelected: this.countSelectedNewsletters})
        },

        ENUM() {
            return ENUM
        },

        calcAll() {
            return this.maxSubscriptions || 0
        },

        calcDone() {
            const treated = this.calcAll - this.subscriptions.length || 0
            return treated >= 0 ? treated : 0
        },

        progress() {
            return `${this.calcDone}/${this.calcAll}`
        },

        percent() {
            return (100 * this.calcDone) / this.calcAll
        },

        computedSortTitle() {
            if (this.showHeaderDesktop) {
                switch (this.newslettersSort) {
                    case ENUM.NEWSLETTERS.SORT.MOST_OPEN:
                        return this.$t('sort_by_most_open')
                    case ENUM.NEWSLETTERS.SORT.LEAST_OPEN:
                        return this.$t('sort_by_less_open')
                    case ENUM.NEWSLETTERS.SORT.ASCENDING:
                        return this.$t('sort_by_ascending')
                    case ENUM.NEWSLETTERS.SORT.DESCENDING:
                        return this.$t('sort_by_descending')
                    case ENUM.NEWSLETTERS.SORT.UP_TO_DATE:
                        return this.$t('sort_by_more_recent')
                    case ENUM.NEWSLETTERS.SORT.OLDEST:
                        return this.$t('sort_by_least_recent')
                    default:
                        return this.$t('sort_emails')
                }
            } else {
                return this.$t('sort_emails')
            }

        },

        isList() {
            return this.newslettersPage === ENUM.NEWSLETTERS.PAGE.LIST && !this.showEmpty
        },


        atLeastOneShutdown() {
            return this.mailboxes.some(mailbox => mailbox.providerShutdown)
        },

        showHeaderDesktop() {
            return this.innerWidth >= 1000
        }
    },

    data() {
        return {
            modelSearchValue: '',
            showFetchDone: false
        }
    },

    methods: {

        ...Vuex.mapActions([
            'unselectAllNewsletters',
            'updateNewslettersSearchingMode',
            'updateSearchValue'
        ]),

        updateCategory(newCategory) {
            this.$emit('updateCategory', newCategory)
        },

        openSort() {
            Tag.clickGA(this, 'sort_emails')
            this.$refs.SORT.open()
        },

        goMyActions() {
            Storage.setItem(Storage.KEYS.NEWSLETTERS_PAGE, this.page)
            this.$router.push({path: '/my-actions'})
        },

        search(bool) {
            this.showHeaderDesktop
                ? Tag.clickGA(this, 'search_cta')
                : Tag.clickGA(this, 'search_email')
            this.unselectAllNewsletters()
            if (bool) {
                this.updateNewslettersSearchingMode(ENUM.NEWSLETTERS.SEARCHING_MODE.SEARCHING)
            } else {
                this.updateSearchValue('')
                this.updateNewslettersSearchingMode(ENUM.NEWSLETTERS.SEARCHING_MODE.UNACTIVE)
                this.$forceUpdate()
            }
        },

        openBSMS() {
            this.$refs.BSMS.open()
        }
    }
}
</script>

<style lang="scss" scoped>

.header {

    &__row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 8px 16px;
        background-color: $timberwolf;

        .desktop-size {
            background-color: $white;
            border-bottom: 1px solid $divider;
        }
    }

    &__border {
        border-bottom: 1px solid #d5D7D1;
    }

    &__mobile {
        &__selected {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 8px 16px 8px 12px;
            border-radius: 72px;
        }

        &__left {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
        }

        &__ghost {
            visibility: hidden;
        }
    }

    &__progress {
        display: flex;
        flex-direction: row;

        &__right {
            text-align: start;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
        }
    }

    &__line {
        display: flex;
        flex-direction: row;
    }


    &__btn {
        &__mail {
            display: flex;
            flex-direction: row;
            padding: 8px 12px 8px 0;
            align-items: center;
            border-radius: 72px;
            background-color: $timberwolf;
            color: $charcoal;

            &__text {
                margin-right: 8px;

                &:lang(ar-sa) {
                    margin-left: 8px;
                    margin-right: 0;
                }
            }

        }

        &__history {
            display: flex;
            flex-direction: row;
            padding: 8px 16px;
            align-items: center;
            background-color: $white;
            border-radius: 72px;

            &__text {
                margin-left: 8px;

                &:lang(ar-sa) {
                    margin-right: 8px;
                    margin-left: 0;
                }
            }
        }

        &__search {
            display: flex;
            background-color: $white;
            align-items: center;
            justify-content: center;
            border-radius: 72px;
            padding: 8px;
            margin-right: 8px;
            width: 36px;
            height: 36px;
            .desktop-size {
                margin-right: 20px;
            }

            &:lang(ar-sa) {
                margin-left: 20px;
                margin-right: 0;
            }

            > p {
                margin-left: 12px;

                &:lang(ar-sa) {
                    margin-left: 0;
                    margin-right: 12px;
                }
            }
        }

        &__sort {
            display: flex;
            flex-direction: row;
            align-items: center;
            background-color: $white;
            border-radius: 72px;
            padding: 8px 16px;
            .desktop-size {
                padding: 8px 12px;
            }

            &__active {
                border: solid 2px $aquamarine;
                color: $aquamarine;
            }

            &__text {
                margin-left: 8px;

                &:lang(ar-sa) {
                    margin-left: 0;
                    margin-right: 8px;
                }
            }
        }
    }

    &__search {
        display: flex;
        flex-direction: row;
        padding: 16px;
        background-color: $timberwolf;

        .desktop-size {
            background-color: $white;
            justify-content: center;
            border-bottom: 1px solid $divider;
        }

        &__label {
            padding: 8px 16px;
            display: flex;
            flex: 1;
            flex-direction: row;
            align-items: center;
            border-radius: 72px;
            background-color: $white;
            max-width: 650px;
            margin-right: 16px;

            &:lang(ar-sa) {
                margin-left: 16px;
                margin-right: 0;
            }

            @media screen and (min-width: $above-tablet-length) {
                border: 2px solid $silver;
                margin-right: 0;

                &:lang(ar-sa) {
                    margin-left: 0;
                }
            }

            > img {
                margin-right: 8px;

                &:lang(ar-sa) {
                    margin-left: 8px;
                    margin-right: 0;
                }
            }
        }

        &__input {
            width: 100%;
        }

        &__input::placeholder {
            font-size: 15px;
            font-weight: 600;
            line-height: 1.41;
            color: $stone;
        }
    }

    &__desktop {
        padding: 16px 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid $silver;

        .desktop-size {
            padding-right: 48px;
            padding-left: 48px;
        }

        &__side {
            display: flex;
            flex-direction: row;
            align-items: center;

            .label {
                padding: 8px 16px;
                border-radius: 64px;
                border: 2px solid $neutralsPlatinum;
                background: $white;
                display: flex;
                flex-direction: row;
                align-items: center;
                font-size: 15px;
                font-weight: 500;
                line-height: 20px;
                cursor: pointer;
            }

            .little-label {
                padding: 8px;
                height: min-content;
            }
        }
    }
}

.header-row-desktop-size {
    padding-right: 48px;
    padding-left: 48px;
}

.divider {
    height: 1px;
    width: 100%;
    background-color: $silver;
}
</style>
